export enum Fulfilment {
    Deliver = 1,
    Takeaway = 2,
    Visit = 3,
}
